




















































































































































import { Component } from 'vue-mixin-decorator';
import { loadStripe } from '@stripe/stripe-js';

import BaseView from '@/views/BaseView.vue';
import ExamFooter from '@/components/ExamFooter.vue';
import ExamGuide from '@/components/ExamGuide.vue';
import ExamNav from '@/components/ExamNav.vue';
import IndicatorModal from '@/components/IndicatorModal.vue';
import SerialCodeCheckbox from '@/components/SerialCodeCheckbox.vue';

import { REGISTER_USER_INFO, EXAMINEE_ITEMS } from '@/classification/SessionStorageKey';

import * as JwtUtil from '@/common/JwtUtil';
import * as StringUtil from '@/common/StringUtil';

import RepositoryFactory from '@/repository/RepositoryFactory';

import ExamInfo from '@/models/exam/ExamInfo';
import CartPurchaseParam from '@/models/cart/apiParam/CartPurchaseParam';
import CartItem from '@/models/cart/CartItem';
import GoodsOption from '@/models/goods/GoodsOption';

@Component(
  {
    components: {
      'e-footer': ExamFooter,
      'e-guide': ExamGuide,
      'e-nav': ExamNav,
      'e-indicator': IndicatorModal,
      SerialCodeCheckbox,
    },
  },
)
export default class GoodsConfirm extends BaseView {
  private isUseSerialcode = false;

  private examInfo = new ExamInfo();

  private jwt = null;

  private GoodsRepository = RepositoryFactory.get().goods;

  private CartRepository = RepositoryFactory.get().cart;

  private isIndicatorDisplay = false;

  private isEntryBadCondition = false;

  private msgEntryBadCondition = '';

  private cartCode = '';

  private cartItem = new CartItem();

  private serialCode = '';

  private async created() {
    this.isIndicatorDisplay = true;
    this.jwt = JwtUtil.getJwtInfo();
    if (this.jwt === null) {
      this.redirectToTOP();
    }

    /* eslint-disable @typescript-eslint/camelcase */
    const { cart_code } = this.$route.query;
    if (cart_code === undefined) {
      this.redirectToTOP();
    }
    // グッズ購入用処理
    this.cartCode = String(cart_code);
    await this.getExamInfo();
    await this.getCartInfo();

    this.isIndicatorDisplay = false;
  }

  private mounted() {
    this.initialStaticScript();
  }

  /**
   * 検定情報を取得する
   */
  private async getExamInfo() {
    try {
      const ExamRepository = RepositoryFactory.get().exam;
      await ExamRepository.getExam().then((response) => {
        this.examInfo.examTitle = response.data.exam_title;
        this.examInfo.useNameFlg = response.data.use_name_flg;
        this.examInfo.useNameKanaFlg = response.data.use_name_kana_flg;
        this.examInfo.useGenderFlg = response.data.use_gender_flg;
        this.examInfo.useAddressFlg = response.data.use_address_flg;
        this.examInfo.useMailAnnounceFlg = response.data.use_mail_announce_flg;
        this.examInfo.usePaymentsKonbiniFlg = response.data.use_payments_konbni_flg;
        this.examInfo.usePaymentsSerialFlg = response.data.use_payments_serial_flg;
        this.examInfo.konbiniExpireDays = response.data.konbini_expire_days;
      }).catch(() => {
        this.redirectToTOP();
      });
    } catch (e) {
      this.redirectToTOP();
    }
  }

  /**
   * 買い物カゴ情報を取得する
   */
  private async getCartInfo() {
    try {
      await this.CartRepository.getCart(this.cartCode).then((response) => {
        if (response.status !== 200) {
          this.redirectToTOP();
        }
        const format = 'YYYY年MM月DD日（dd） HH:mm:ss';
        const cart_item = response.data.cart_items[0];
        this.cartItem.goodsCode = cart_item.goods_code;
        this.cartItem.goodsTitle = cart_item.goods_title;
        this.cartItem.quantity = Number(cart_item.quantity);
        this.cartItem.canBuy = cart_item.can_buy;
        this.cartItem.fee = Number(cart_item.fee.fee);
        this.cartItem.periodStart = StringUtil.toJapanDateString(cart_item.sale_period_start, format);
        this.cartItem.periodEnd = StringUtil.toJapanDateString(cart_item.sale_period_end, format);

        if (cart_item.cart_item_options !== undefined && Array.isArray(cart_item.cart_item_options)) {
          cart_item.cart_item_options.forEach((v: any) => {
            const goodsOption = new GoodsOption();
            goodsOption.goodsOptionId = v.goods_option_id;
            goodsOption.goodsOptionTypeTitle = v.goods_option_type_title;
            goodsOption.optionTitle = v.option_title;
            this.cartItem.goodsItemOptions.push(goodsOption);
          });
        }
        if (!this.cartItem.canBuy) {
          this.$router.replace({ path: this.paths.PURCHASE_CANNOT_PURCHASE });
        }
      }).catch(() => {
        this.redirectToTOP();
      });
    } catch (e) {
      this.redirectToTOP();
    }
  }

  /**
   *  決済の実行
   */
  private async purchaseSubmit() {
    this.isIndicatorDisplay = true;
    this.isEntryBadCondition = false;
    this.msgEntryBadCondition = '';

    // SessionStorageの登録情報を削除 // 会員登録とは別手続きになったので無用だが念の為
    sessionStorage.removeItem(REGISTER_USER_INFO);
    sessionStorage.removeItem(EXAMINEE_ITEMS);

    if (!this.cartItem.canBuy) {
      this.$router.replace({ path: this.paths.PURCHASE_CANNOT_PURCHASE });
      return;
    }

    await this.purchaseCart();
  }

  /** グッズの購入手続き */
  private async purchaseCart() {
    try {
      let sessionId = null;
      const param = new CartPurchaseParam();
      param.cartCode = this.cartCode;
      param.serialCode = this.serialCode;
      await this.CartRepository.purchaseCart(param).then((response: any) => {
        sessionId = response.data.stripe_session_id;
      }).catch((err) => {
        if (err.response.status === 400) {
          this.isEntryBadCondition = true;
          this.msgEntryBadCondition = String(err.response.data.error).replace(/\r?\n/g, '<br/>');
          if (this.msgEntryBadCondition === 'undefined') {
            this.msgEntryBadCondition = '購入手続きに失敗しました。';
          }
        } else {
          this.isEntryBadCondition = true;
          this.msgEntryBadCondition = '購入手続きに失敗しました。';
        }
      });

      if (this.isEntryBadCondition) return;

      if (sessionId === null) {
        // eslint-disable-next-line @typescript-eslint/camelcase
        this.$router.replace({ path: this.paths.GOODS_DETAIL, query: { goods_code: this.cartItem.goodsCode } });
      } else {
        // セッションIDを使ってCheckout（Stripeの支払い画面）にリダイレクト
        const stripe = await loadStripe(String(process.env.VUE_APP_STRIPE_SITE_KEY));
        if (stripe !== null) {
          stripe.redirectToCheckout({ sessionId });
        }
      }
    } catch (_) {
      JwtUtil.deleteJwt();
    } finally {
      this.isIndicatorDisplay = false;
    }
  }

  /**
   * CSSとJSの読み込み
   */
  private initialStaticScript() {
    const CommonCss = document.createElement('link');
    CommonCss.rel = 'stylesheet';
    CommonCss.href = '/css/common.css';
    this.$el.appendChild(CommonCss);

    const AccountCommonCss = document.createElement('link');
    AccountCommonCss.rel = 'stylesheet';
    AccountCommonCss.href = '/account/css/common.css';
    this.$el.appendChild(AccountCommonCss);

    const ConfirmCss = document.createElement('link');
    ConfirmCss.rel = 'stylesheet';
    ConfirmCss.href = '/css/goods/css/confirm.css';
    this.$el.appendChild(ConfirmCss);

    this.getExamConfigCss().then((cssElement: HTMLLinkElement) => {
      this.$el.appendChild(cssElement);
    });

    const CommonJs = document.createElement('script');
    CommonJs.src = '/js/common.js';
    this.$el.appendChild(CommonJs);
  }

  /**
   * TOP画面に遷移
   */
  private redirectToTOP() {
    this.$router.replace(this.paths.TOP);
  }

  /**
   * シリアルコード使用のチェック切り替え
   */
  private changeCheckBox() {
    this.isUseSerialcode = !this.isUseSerialcode;
    // シリアルコード使用のチェックを外した場合、シリアルコード入力欄・エラー表示をリセット
    if (this.isUseSerialcode === false) {
      this.serialCode = '';
      this.isEntryBadCondition = false;
      this.msgEntryBadCondition = '';
    }
  }

  // eslint-disable-next-line class-methods-use-this
  formatPrice(fee: number): string {
    return StringUtil.separateNumber(fee);
  }
}
